import { SettingsPageWrapper } from "features/settings/common/styles";
import BasicInfo from "features/settings/Security/BasicInfo";
import TwoFA from "features/settings/Security/TwoFA/TwoFA";
import GeneralSettings from "features/settings/Security/GeneralSettings";
import ExternalAccountsSection from "features/settings/Security/ExternalAccounts/ExternalAccountsSection";
import { useContext, useEffect } from "react";
import { AnalyticsContext } from "analytics/AnalyticsProvider";
import { IS_WHOP } from "common/constants";
import { useIsSubUser, useSelectUser } from "@shared/utils/hooks/misc.ts";
import { IS_TELEGRAM_WEB_APP } from "features/telegram/constants";
import { useTheme } from "styled-components";

export const Security = () => {
  const { analytics } = useContext(AnalyticsContext);
  const isSubUser = useIsSubUser();
  const user = useSelectUser();
  const { isNewLook } = useTheme();
  const showTwoFA = !IS_TELEGRAM_WEB_APP && !IS_WHOP;
  // The new look moves the password row into the security card.
  const passwordInSecurity = isNewLook && showTwoFA;

  useEffect(() => {
    analytics?.settingsUserSettingsView({});
  }, [analytics]);

  return (
    <SettingsPageWrapper>
      <BasicInfo hidePassword={passwordInSecurity} />
      {!isSubUser && !user?.isWhopExperience() && <ExternalAccountsSection />}
      {showTwoFA && <TwoFA showPassword={passwordInSecurity} />}
      {!IS_WHOP && <GeneralSettings />}
    </SettingsPageWrapper>
  );
};
